import { render } from "./Coupon.vue?vue&type=template&id=709156c2"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"
script.render = render

export default script